export const menu = [
  // {
  //   label: { en: "HOME", vi: "Trang Chủ" },
  //   type: "scroll",
  //   path: "/",
  //   children: [],
  // },

  {
    label: { en: "About", vi: "Giới Thiệu" },
    type: "dropdown",
    path: "/about",
    showHeader: true,
    children: [
      {
        label: { en: "About Maria Pooley", vi: "Về Maria Pooley" },
        path: "/about#maria",
      },
      {
        label: { en: "Our Approach", vi: "Về Maria Pooley" },
        path: "/about#approach",
      },

      {
        label: { en: "Our Team & Expertise", vi: "Đội Ngũ & Chuyên Môn" },
        path: "/about#team",
      },
      {
        label: { en: "Who We Help", vi: "Đối Tượng Chúng Tôi Hỗ Trợ" },
        path: "/about#clients",
      },
      {
        label: { en: "Why Choose Us", vi: "Vì Sao Chọn Chúng Tôi" },
        path: "/about#why-us",
      },
      {
        label: { en: "Success Stories", vi: "Câu Chuyện Thành Công" },
        path: "/about#success",
      },
    ],
  },

  {
    label: { en: "Services", vi: "Dịch Vụ" },
    type: "dropdown",
    path: "/services", // ✅ ADD THIS

    children: [
      {
        label: {
          en: "Business Consulting Service",
          vi: "Dịch Vụ Tư Vấn Doanh Nghiệp",
        },
        path: "/services/business-consulting#businessconsulting",
      },
      {
        label: {
          en: "Business Investment Advisory",
          vi: "Tư Vấn Đầu Tư Doanh Nghiệp",
        },
        path: "/services/business-investment#businessinvestmentadvisory",
      },
      {
        label: {
          en: "Property Investment Advisory",
          vi: "Tư Vấn Đầu Tư Bất Động Sản",
        },
        path: "/services/property-investment#propertyadvisory",
      },
      {
        label: {
          en: "Business Coaching & Training",
          vi: "Huấn Luyện & Đào Tạo Doanh Nghiệp",
        },
        path: "/services/training-coaching#trainingcoaching",
      },
      {
        label: {
          en: "Leadership & Personal Development",
          vi: "Phát Triển Lãnh Đạo & Bản Thân",
        },
        path: "/services/leadership-development#consulting",
      },
      {
        label: {
          en: "Become a Coach & Coaching Business",
          vi: "Trở Thành Coach & Phát Triển Coaching",
        },
        path: "/services/coach-training#trainning",
      },
    ],
  },

  {
    label: { en: "Events", vi: "Sự Kiện" },
    type: "dropdown",
    children: [
      {
        label: {
          en: "Our Events",
          vi: "Các Sự Kiện",
        },

        path: "/events#upcoming",
      },

      // {
      //   label: {
      //     en: "Private Sessions",
      //     vi: "Tư Vấn Riêng",
      //   },

      //   path: "/events#private",
      // },

      {
        label: {
          en: "Book Your Session",
          vi: "Đặt Lịch Tư Vấn",
        },

        path: "/events#book",
      },
    ],
  },

  // {
  //   label: { en: "Networks", vi: "Kết Nối" },
  //   type: "dropdown",
  //   path: "/networks", // ✅ ADD THIS

  //   children: [
  //     {
  //       label: { en: "BDI Business Network", vi: "Mạng Lưới BDI" },
  //       path: "/networks#bdi",
  //     },
  //     {
  //       label: { en: "VBON Business Owners", vi: "Chủ Doanh Nghiệp VBON" },
  //       path: "/networks#vbon",
  //     },
  //     {
  //       label: { en: "VBC Business Coaches", vi: "Coach Doanh Nghiệp VBC" },
  //       path: "/networks#vbc",
  //     },
  //   ],
  // },

  {
    key: "insights",

    label: { en: "Insights", vi: "Phân Tích" },
    type: "scroll",
    path: "/insights#insight",

    children: [
      {
        label: {
          en: "Insights",
          vi: "Phân Tích",
        },
        path: "/insights",
      },
      // {
      //   label: {
      //     en: "Training & Coaching Industry ",
      //     vi: "Hiệp Hội Đào Tạo & Coaching",
      //   },
      //   path: "/insights",
      // },
      // {
      //   label: {
      //     en: "Market Research & Trend Platforms",
      //     vi: "Nghiên Cứu Thị Trường & Xu Hướng",
      //   },
      //   path: "/insights",
      // },
    ],
  },

  {
    key: "clients&partners",

    label: {
      en: "Network",
      vi: "Mạng lưới",
    },
    path: "/networks",

    type: "dropdown",

    children: [
      // {
      //   label: {
      //     en: "Success Stories",
      //     vi: "Câu Chuyện Thành Công",
      //   },

      //   path: "/community#successstories",
      // },
      // {
      //   label: {
      //     en: "Our Clients",
      //     vi: "Khách Hàng",
      //   },

      // path: "/networks#ourclient",
      // },
      {
        label: {
          en: "Our Networks",
          vi: "Mạng lưới",
        },

        path: "/networks#networks",
      },

      {
        label: {
          en: "Partnership Opportunities",
          vi: "Cơ hội hợp tác",
        },

        path: "/networks#ourpartners",
      },
    ],
  },

  {
    label: { en: "Contact Us", vi: "Liên Hệ" },
    type: "scroll",
    path: "/contact",
    children: [
      // {
      //   label: { en: "Book a Consultation", vi: "Đặt Lịch Tư Vấn" },
      //   path: "/contact#booking",
      // },
      {
        label: { en: "Send Your Enquiry", vi: "Gửi Yêu Cầu" },
        path: "/contact",
      },
    ],
  },
];
